// :cow: Cosmose CONFIDENTIAL :iso:
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, STATE_NAME_SELECT_VIDEO_PROVIDER } from './select-video-provider.reducer';

const currentState = createFeatureSelector<State>(STATE_NAME_SELECT_VIDEO_PROVIDER);

export const selectVideoProviderListResponse = createSelector(
  currentState,
  (state: State) => state.response,
);

export const selectVideoProviderListError = createSelector(
  currentState,
  (state: State) => state.responseError,
);

export const selectVideoProviderListShowSkeleton = createSelector(
  currentState,
  (state: State) => state.responseLoading,
);


